<template>
  <CRow>
    <CCol col="6" :md="{offset: '3'}">
      <CCard>
        <CCardHeader color="dark" class="text-white">
          Dados do usuário          
        </CCardHeader>
        <CCardBody>

          <CRow>
            <CCol col="6">
              <CInput
                label="Nome"
                v-model="form.name"
              />
            </CCol>
            <CCol col="6">
              <CInput
                label="Email"
                v-model="form.email"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <label>Perfis</label>
              <v-select :options="roles" multiple v-model="form.roles"></v-select>
            </CCol>
          </CRow>

        </CCardBody>
        <CCardFooter>
          <CButton color="danger" @click="cancel">Cancelar</CButton>
          <CButton color="success" @click="save">Salvar</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'PUser',
  components: {
    vSelect
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        roles: [],
      },
      roles: [],
    }
  },
  mounted () {

    this.$http.get('/api/roles')
    .then(res => {
      if (res.status === 200)
      {
        this.roles = res.data.roles
      }
    })
    .catch(error => {
        
    });

    if (this.$route.params.id > 0)
    {
      this.$http.get('/api/pusers/' + this.$route.params.id)
      .then(res => {
        if (res.status === 200)
        {
          this.form = res.data.puser
        }
      })
      .catch(error => {
          
      });
    }
  },
  methods: {
    cancel () {
      this.$swal({
        icon: 'warning',
        title: 'Atenção',
        text: 'Deseja realmente cancelar?',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({'path': '/users/1'})
        }
      })
    },
    save () {
      if (this.$route.params.id == 0)
      {
        this.$http.post('/api/pusers', this.form)
        .then(res => {
          if (res.status === 200)
          {
            if (res.data.code === 0)
            {
              this.$swal({
                icon: 'success',
                title: 'Usuário adicionado com sucesso!',
              })
              this.$router.push({'path': '/users/1'})
            }
          }
        })
        .catch(error => {
            
        });
      } else {
        this.$http.put('/api/pusers/'+this.$route.params.id, this.form)
        .then(res => {
          if (res.status === 200)
          {
            if (res.data.code === 0)
            {
              this.$swal({
                icon: 'success',
                title: 'Alterações salvas com sucesso!',
              })
              this.$router.push({'path': '/users/1'})
            }
          }
        })
        .catch(error => {
            
        });
      }
    },
  }

}
</script>
<style scoped>
.card-footer button.btn-success{
  float:right;
}
.card-footer button.btn-danger{
  float:left;
}
</style>